export default "__VITE_ASSET__DKabo227__"